var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYarnHook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 140,
    viewBox: "0 0 136 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.8467,
    cy: 60.8467,
    r: 60.8467,
    transform: "matrix(-1 0 0 1 126.152 14.2803)",
    stroke: "#EEC0CB",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.462 37.9805C114.462 37.9805 80.5175 88.1656 29.401 123.042",
    stroke: "#EEC0CB",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0289 28.0463C72.0289 28.0463 63.1326 21.1101 59.6112 15.6286",
    stroke: "#EEC0CB",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5805 39.8868C61.5805 39.8868 49.6509 30.9977 41.9741 18.6266",
    stroke: "#EEC0CB",
    strokeWidth: 8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5748 62.4875C43.5748 62.4875 25.3624 52.1335 17.0986 36.0113",
    stroke: "#EEC0CB",
    strokeWidth: 8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2704 72.1667C33.2704 72.1667 17.6637 63.7977 9.18252 48.079",
    stroke: "#EEC0CB",
    strokeWidth: 8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8438 82.6842C21.8438 82.6842 10.3575 76.2623 4.35258 65.1929",
    stroke: "#EEC0CB",
    strokeWidth: 8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5008 104.04C93.6855 113.639 108.374 116.51 108.374 116.51",
    stroke: "#EEC0CB",
    strokeWidth: 8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1059 115.696C80.627 126.366 92.8645 128.906 92.8645 128.906",
    stroke: "#EEC0CB",
    strokeWidth: 8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4452 47.9672C44.7065 49.238 45.8247 50.3626 46.7584 51.3006L48.8457 48.8504C47.8615 47.7279 46.5936 46.2845 45.1146 44.6068C41.4726 40.4758 36.5546 34.9285 31.4451 29.2577C26.3316 23.5826 21.0443 17.8036 16.6587 13.2016C14.4638 10.8984 12.5177 8.9142 10.9446 7.39429C9.28202 5.78804 8.27261 4.93532 7.86712 4.67175C6.1564 3.55978 4.87483 4.06226 4.40477 4.50412C4.16347 4.73094 4.01937 5.01577 4.00183 5.39043C3.98396 5.77215 4.0906 6.54464 4.90008 7.65767C5.9558 9.10929 9.19836 12.6998 13.7501 17.5176C18.2083 22.2364 23.6998 27.902 29.0487 33.3673C34.3952 38.83 39.5882 44.081 43.4452 47.9672Z",
    fill: "#5B3B52",
    stroke: "#5B3B52",
    strokeWidth: 8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1835 16.8632C82.1835 16.8632 55.0612 59.2945 7.05649 91.3693",
    stroke: "#EEC0CB",
    strokeWidth: 8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.349 26.0771C100.349 26.0771 68.7151 72.9827 15.5071 110.218",
    stroke: "#EEC0CB",
    strokeWidth: 8
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129.003 120.452C126.52 116.726 98.2126 90.9595 96.0966 90.0282L90.819 95.9266C92.0038 96.8579 117.517 120.452 120.932 122.625C124.347 124.798 120.058 126.971 119.38 130.075C118.702 133.18 124.347 133.49 129.003 130.075C133.66 126.66 131.487 124.177 129.003 120.452Z",
    fill: "#5B3B52",
    stroke: "#5B3B52",
    strokeWidth: 8
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.913 55.9861C121.913 55.9861 92.3143 103.688 46.1649 131.734",
    stroke: "#EEC0CB",
    strokeWidth: 8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYarnHook);
export default __webpack_public_path__ + "static/media/yarn-hook.46b83f9338d0a2bbca62aae68585aaa6.svg";
export { ForwardRef as ReactComponent };